// Auth API Service
import { API_URL } from '../config';

const TOKEN_STORAGE_KEY = 'auth_token';

// Helper function to store token
const storeToken = (token) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
};

// Helper function to retrieve token
const getToken = () => {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
};

// Helper function to clear token
const clearToken = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
};

// Helper function to create authenticated headers
const getAuthHeaders = (additionalHeaders = {}) => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...additionalHeaders
  };
};

export const authApiService = {
  async login(username, password) {
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });
    if (!res.ok) throw new Error('Invalid credentials');
    const data = await res.json();
    // Store the token from the response
    if (data.token) {
      storeToken(data.token);
    }
    return data;
  },

  async register(username, password, role = 'user') {
    const res = await fetch(`${API_URL}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, role })
    });
    if (!res.ok) throw new Error('Registration failed');
    const data = await res.json();
    // Store the token from the response if available
    if (data.token) {
      storeToken(data.token);
    }
    return data;
  },

  logout() {
    clearToken();
  },

  getStoredToken() {
    return getToken();
  },

  async getUsers() {
    const res = await fetch(`${API_URL}/users`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Not authorized');
    return res.json();
  },

  async updateUserRole(id, role) {
    const res = await fetch(`${API_URL}/users/${id}/role`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ role })
    });
    if (!res.ok) throw new Error('Failed to update role');
    return res.json();
  }
};
